import React from "react";
import ReactFileReader from "react-file-reader";
import PostFilesAxios from "../axiosComponent/postFilesAxios";
import cogoToast from "cogo-toast";
import { isFileValid } from "../../utils/validation";


const UploadFile = ({ field: { name }, form: { setFieldValue }, ...props }) => {
    const handleFiles = (files) => {
        if (props.typer) {
            const validTypes = props.typer;
            const maxFileSize = 5000000

            const fileValidationResult = isFileValid(files.fileList[0], validTypes, maxFileSize);

            if (fileValidationResult.error) {
                cogoToast.error(fileValidationResult.message, { position: 'top-right' });
                return;
            }
        }

        let data = {
            documentContent: files.fileList[0],
            documentName: name,
            orderNo: props.values.orderNo ? props.values.orderNo : "",
            deliveryNo: props.values.deliveryNo ? props.values.deliveryNo : "",
        };
        PostFilesAxios({
            url: props.upload_url ? props.upload_url : `masters/transporterMaster/addDocument`,
            createItems: data,
        })
            .then((res) => {
                setFieldValue(name, res?.data?.key ? res.data.key : res?.data?.message?.key);
            })
            .catch((err) => { console.log(err); cogoToast.error(err); })
    };

    return (
        <>
            <ReactFileReader
                base64={true}
                fileTypes={props.typer}
                handleFiles={handleFiles}
                {...props}
            >
                <button type="button" className={props.className}>
                    <i className="fas fa-upload"></i> {props.buttonName}
                </button>
            </ReactFileReader>
        </>
    );
};

export default UploadFile;
